import { clientAxios } from '../../../config'

export const getSellersHomeData = async ({ fDate, eDate }) => {
    try {
        const resultGetSellersHomeData = await clientAxios.get('/sellers.php', {
            params: {
                fDate: fDate,
                eDate: eDate,
                division: "hogar"
            },
        })
        const { result, message = "", error_msg } = resultGetSellersHomeData.data
        return { result, message, error_msg }

    } catch (error) {
        if ("response" in error) {
            const { response } = error
            const { data } = response
            const { result = [], message = "", error_msg = "" } = data
            return { result, message, error_msg }
        } else {
            const result = [], message = "An error has ocurred", error_msg = ""
            return { result, message, error_msg }
        }
    }
}